import React, { useState } from "react";
import { Form, Input } from "antd";
import { Link } from "react-router-dom";
import Image from "../../../common/image/Image";
import MarketLogo from "../../../../assets/images/Onetransfer-logo-wbg.png";
import {
	AlertBox,
	Body,
	Container,
	Footer,
	ForgotLink,
	ForgotLinkWrap,
	Header,
	HeaderDesc,
	HeaderTitle,
	InnerForm,
	LogoWrap,
	Main,
	Page,
	PrimaryButtonWrap,
	TrustDot,
	TrustItem,
	TrustRow,
} from "./styles";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import { send_password_reset_email } from "../../../../api/endpoints/auth";
import {
	ClockCircleOutlined,
	LockOutlined,
	MailOutlined,
	RollbackOutlined,
	SafetyOutlined,
} from "@ant-design/icons";
import SignInTemplate from "../../../layout/sign-in-template/SignInTemplate";

export default function ForgotPassword() {
	const [form] = Form.useForm();
	const [submitting, setSubmitting] = useState(false);
	const [mailSent, setMailSent] = useState(false);

	const onFinish = async (values) => {
		try {
			setSubmitting(true);

			await send_password_reset_email(values.email);

			setMailSent(true);
			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Correo enviado",
				"Verifique su casilla de correo",
			);
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"No se pudo enviar el correo",
				"Un error ocurrió al intentar enviar el reset de password.",
			);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<SignInTemplate columns="1">
			<Page>
				<Main>
					<LogoWrap>
						<Image
							src={MarketLogo}
							alt="Logo One Transfer"
							height="45px"
							width="220px"
						/>
					</LogoWrap>

					<Header>
						<HeaderTitle>Restablecer contraseña</HeaderTitle>
						<HeaderDesc>
							Ingresá tu email y te enviaremos un enlace para recuperar el
							acceso
						</HeaderDesc>
					</Header>

					<Body>
						<Form
							form={form}
							name="forgot-password-form"
							onFinish={onFinish}
							requiredMark={false}
							layout="vertical"
						>
							<InnerForm>
								{mailSent && (
									<AlertBox $success>
										Te enviamos un correo con instrucciones para restablecer tu
										contraseña.
									</AlertBox>
								)}

								<Form.Item
									name="email"
									label="Email"
									rules={[
										{
											required: true,
											message: "Este campo es obligatorio",
										},
										{
											type: "email",
											message: "Ingrese un email válido",
										},
									]}
								>
									<Input
										placeholder="usuario@empresa.com"
										type="email"
										size="large"
										prefix={<MailOutlined />}
									/>
								</Form.Item>

								<Container>
									<PrimaryButtonWrap>
										<SignInTemplate.AntdButton
											htmlType="submit"
											loading={submitting}
											type="primary"
											color="White"
											bg="Secondary"
											icon={<LockOutlined />}
										>
											Restablecer contraseña
										</SignInTemplate.AntdButton>
									</PrimaryButtonWrap>

									<ForgotLinkWrap>
										<ForgotLink>
											<Link to="/signin">
												<RollbackOutlined style={{ marginRight: 6 }} />
												Volver a iniciar sesión
											</Link>
										</ForgotLink>
									</ForgotLinkWrap>
								</Container>

								<Footer>
									Si el email existe en el sistema, recibirás instrucciones en
									unos minutos.
								</Footer>

								<TrustRow>
									<TrustItem>
										<SafetyOutlined />
										Conexión segura
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<LockOutlined />
										Datos encriptados
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<ClockCircleOutlined />
										Disponible 24/7
									</TrustItem>
								</TrustRow>
							</InnerForm>
						</Form>
					</Body>
				</Main>
			</Page>
		</SignInTemplate>
	);
}
